import React from 'react'
import Navigation from '../Navigation'
import { Grid, Container, Avatar, Typography,  Box, CircularProgress} from '@mui/material'
import TeacherProfileTabs from '../Teacher/TeacherProfileTab'
import { getTeacher } from '../../repo/firebaseFunctions';
import { useState, useEffect} from 'react'
import { useLocation } from 'react-router-dom';

function TeacherProfile(props) {
    const [isLoading, setIsLoading] = useState(true);
    const [teacher, setTeacher] = useState();
    
    const location = useLocation();
    const teacherId = location.state;

    useEffect(() => {
      async function fetchData() {
        // const schoolId = localStorage.getItem('uid') ?? 
        const teacher = await getTeacher(teacherId); 
        setTeacher(teacher);
        setIsLoading(false);
      }
      fetchData();
    }, []);
    return (
        <Navigation heading={"Teacher's Profile"}>
            {isLoading ? 
            <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '30%' }}>
            <CircularProgress />
          </div>
            :<LargeCard teacher={teacher} />}

            
        </Navigation>
    )
}

export default TeacherProfile


function LargeCard(props) {

    return (
        <Grid item xs={12} >
            <Container sx={{ backgroundColor: '#D2E9EE', minWidth: "800px", padding: "60px", marginTop: "60px", borderRadius: "25px", boxShadow: 3 }}>
                <div style={{ display: 'flex' }}>
                    <div style={{ marginTop: 'auto', marginBottom: 'auto', marginRight: '36px', marginLeft: "36px" }}>
                        <Avatar
                            alt={props.teacher.name}
                            src="/static/images/avatar/1.jpg"
                            sx={{ bgcolor: '#8767A8', width: 100, height: 100 }}
                        />
                    </div>
                    <div>
                        <Typography style={{ fontWeight: 'bolder', fontSize: '22px', marginBottom: '0px' }}>{props.teacher.name}</Typography>
                        <Typography style={{ fontWeight: 'bold', fontSize: '16px', marginTop: "0px" }}>{props.teacher.courseID}</Typography>
                        <Typography style={{ fontSize: '16px' }}>{props.teacher.email}</Typography>
                    </div>
                </div>
            </Container>
            <Box
                direction='column'
                maxHeight='80vh'
                display='flex'
                justifyContent='center'
                alignItems='center'
            >
                <TeacherProfileTabs teacher ={props.teacher}/>
            </Box>

        </Grid>
    )
}

